<div class="dropdown d-inline-block" dropdown *ngIf="user">
  <button type="button" class="btn header-item" dropdownToggle id="page-header-user-dropdown">
    <img
      class="rounded-circle header-profile-user"
      src="{{
        user.profile.media
          ? user.profile.media.url
          : 'https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable'
      }}"
      alt="Avatar"
    />
    <span class="d-none d-xl-inline-block ms-1"> {{ user.firstName }} {{ user.lastName }} </span>
    <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
  </button>
  <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
    <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
      <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
      Logout
    </a>
  </div>
</div>
